import Handler from "./Handler";
import DiscussionModel from "../models/DiscussionModel";
import * as Immutable from "immutable";
import CommentModel from "../models/CommentModel";
import Modifiers from "../models/Modifiers";

export default class RatingHandler extends Handler {

    public handle(model: DiscussionModel, action: string, params?: any): DiscussionModel {
        switch (action) {
            case "rating":
                return this.handleRating(model, params);
            case "rating/result":
                return this.handleResult(model, params);
            default:
                return model;
        }
    }

    private handleResult(model: DiscussionModel, params: {
        comment: number;
        rating: number;
    }): DiscussionModel {
        model = Modifiers.setCommentRating(model, params.comment, params.rating);
        return model;
    }

    private handleRating(model: DiscussionModel, params: {
        comment: number;
        type: "+" | "-";
    }): DiscussionModel {

        const comment = model.getComment(params.comment);
        const rating = model.getRating(params.comment);

        if (comment) {
            if (model.getUser()) {

                let weight = 0;
                if (params.type == "+" && !(rating && rating.getWeight() > 0)) {
                    weight = 1;
                }
                if (params.type == "-" && !(rating && rating.getWeight() < 0)) {
                    weight = -1;
                }

                model = Modifiers.setRating(model, params.comment, weight);

                if (params.type == "+") {
                    if (rating) {
                        if (rating.getWeight() > 0) {
                            model = Modifiers.updateCommentRating(model, params.comment, -1);
                        } else {
                            model = Modifiers.updateCommentRating(model, params.comment, +2);
                        }
                    } else {
                        model = Modifiers.updateCommentRating(model, params.comment, +1);
                    }
                }

                if (params.type == "-") {
                    if (rating) {
                        if (rating.getWeight() < 0) {
                            model = Modifiers.updateCommentRating(model, params.comment, +1);
                        } else {
                            model = Modifiers.updateCommentRating(model, params.comment, -2);
                        }
                    } else {
                        model = Modifiers.updateCommentRating(model, params.comment, -1);
                    }
                }

                this
                    .fetch("rate", {
                        project: model.getProject(),
                        discussion: model.getDiscussion(),
                        comment: comment.getCommentId(),
                        weight: weight,
                    })
                    .then((response) => {
                        if (typeof(response.result) == "number") {
                            this.dispatch("rating/result", {
                                comment: comment.getCommentId(),
                                rating: response.result,
                            });
                        } else {
                            this.dispatch("error", 3);
                        }
                    })
                    .catch(() => {
                        this.dispatch("error", 3);
                    })

            } else {
                this.dispatch("login", 2);
            }
        }

        return model;

    }

}